<template>
  <div class="search-customer">
    <search-customer-modal
      :show="showModal === 'customer-modal'"
      :disable-add-customer="disableAddCustomer"
      :page-type="pageTypes.CHANGE_ORDER"
      @select-customer="selectCustomer"
      @close="showModal = false"
    />

    <search-company-modal
      :show="showModal === 'company-modal'"
      :page-type="pageTypes.CHANGE_ORDER"
      @close="hideModalAndResetCompanies"
    />

    <app-button data-qa="customer-search-button" @click="showModal = 'customer-modal'">
      {{ i18n.t('/KlantZoekenModal/ZoekKlant') }}
    </app-button>
    <app-button data-qa="company-search-button" @click="addCompanyClick">
      {{ i18n.t('/Company/AddCompany') }}
    </app-button>
  </div>
</template>

<script>
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import SearchCustomerModal from '@/components/generic/presentational/organisms/searchCustomerModal/SearchCustomerModal.vue'
import SearchCompanyModal from '@/components/generic/presentational/organisms/searchCompanyModal/SearchCompanyModal.vue'
import CustomerSearchHelper from '@/helpers/CustomerSearchHelper'
import { pageTypes } from '@/helpers/pageTypeConstants'

export default {
  components: {
    SearchCustomerModal,
    SearchCompanyModal,
    AppButton,
  },
  props: {
    translations: {
      type: Object,
      default: () => {},
    },
    disableAddCustomer: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['selectCustomer'],
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      showModal: false,
    }
  },
  computed: {
    pageTypes() {
      return pageTypes
    },
  },
  methods: {
    async hideModalAndResetCompanies() {
      this.showModal = false
      this.$store.dispatch('companies/resetRecommendedCompany')
    },
    selectCustomer(customer) {
      const parsedAddress = CustomerSearchHelper.parseAddress(customer.CustomerAddress)
      customer.CustomerStreet = parsedAddress.street
      customer.CustomerHouseNumber = parsedAddress.houseNumber
      this.$emit('selectCustomer', customer)
    },
    async addCompanyClick() {
      this.showModal = 'company-modal'
    },
  },
}
</script>
